import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatError } from "../lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatError(err, "Credenciales incorrectas"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-sand flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-cream border border-clay/15 rounded-3xl p-10">
        <p className="font-script text-4xl text-clay text-center">Emma & Jhonny</p>
        <p className="mt-2 text-center text-[11px] uppercase tracking-[0.35em] text-stone">Panel de administración</p>
        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <label className="block text-[11px] uppercase tracking-[0.3em] text-stone mb-2">Correo</label>
            <input
              data-testid="admin-login-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-sand border border-clay/20 rounded-2xl px-5 py-4 text-sm text-ink focus:outline-none focus:border-clay transition-colors"
            />
          </div>
          <div>
            <label className="block text-[11px] uppercase tracking-[0.3em] text-stone mb-2">Contraseña</label>
            <input
              data-testid="admin-login-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-sand border border-clay/20 rounded-2xl px-5 py-4 text-sm text-ink focus:outline-none focus:border-clay transition-colors"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-800 text-center">
              {error}
            </p>
          )}
          <button
            data-testid="admin-login-submit-button"
            type="submit"
            disabled={loading}
            className="w-full rounded-full bg-clay text-cream py-4 text-[11px] uppercase tracking-[0.3em] hover:bg-clay-deep transition-colors disabled:opacity-60"
          >
            {loading ? "Entrando…" : "Entrar"}
          </button>
        </form>
        <a data-testid="admin-back-home" href="/" className="block mt-8 text-center text-[11px] uppercase tracking-[0.25em] text-stone hover:text-clay transition-colors">
          Volver a la invitación
        </a>
      </div>
    </div>
  );
}
